export default "__VITE_ASSET__bc3a809b__"